// Chakra imports
import { Flex } from '@chakra-ui/react';

// Custom components
import Logo from 'components/Logo/Logo';
import { HSeparator } from 'components/Separator/Separator';
import { AppConfig } from 'config';

export function SidebarBrand(props: { mini: boolean; hovered: boolean }) {
  const { mini, hovered } = props;
  //   Chakra color mode
  return (
    <Flex alignItems="center" flexDirection="column">
      <Logo
        h="auto"
        w="175px"
        my="32px"
        display={
          mini === false
            ? 'block'
            : mini === true && hovered === true
            ? 'block'
            : 'none'
        }
      />
      <Logo
        h="auto"
        w="64px"
        my="16px"
        display={
          mini === false
            ? 'none'
            : mini === true && hovered === true
            ? 'none'
            : 'block'
        }
      />
      <HSeparator mb="20px" />
    </Flex>
  );
}

export default SidebarBrand;
